module.exports = __webpack_public_path__ + "static/media/ca.c976442e.svg";